import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useDispatch, useSelector } from "react-redux";
import { getCollabMissions, setCollabMissions } from "../../components/teams/teamsSlice";
import { use } from "react";
import moment from "moment";
import { Localize } from "../../app/lang/langs";


export default function MissionHistoryModal(props) {
    let visible = props.visible;
    let setVisible = props.setVisible;
    let collabId = props.collabId;

    const dispatch = useDispatch();

    const missionHistory = useSelector((state) => state.teams.collabMissions);
    const [missionHistoryFlat, setMissionHistoryFlat] = useState([]);

    useEffect(() => {
        if (missionHistory) {
            setMissionHistoryFlat([
                ...(missionHistory.upcomingMissions || []),
                ...(missionHistory.ongoingMissions || []),
                ...(missionHistory.pastMissions || [])
            ]);
        }
    }, [missionHistory]);


    useEffect(() => {
        if (visible) {
            // Fetch mission history data based on collabId
            // This could be a Redux action or an API call
            // For example: dispatch(fetchMissionHistory(collabId));
            dispatch(getCollabMissions({ id_collab: collabId }));
        }
    }, [visible, collabId]);

    const dateBodyTemplate = (rowData, column) => {
        let date = moment(rowData[column.field]);
        return date.isValid() ? date.format("DD/MM/YYYY") : "N/A";
    }

    const onhide = () => {
        setVisible(false);
        setMissionHistoryFlat([]);
        dispatch(setCollabMissions([]));
    }

    return (
        <Dialog
            header="Mission History"
            visible={visible}
            onHide={() => onhide()}
            style={{ width: "60vw", maxWidth: 900 }}
            modal
            draggable={false}
            resizable={false}
        >
            {missionHistoryFlat.length > 0 ? (
                <DataTable
                    value={missionHistoryFlat}
                    scrollable
                    sortMode="single"
                    globalFilter={null}
                    emptyMessage="No mission history found."
                >
                    <Column field="team_name" header="Equipe" sortable />
                    <Column field="poste_name" header="Poste" sortable />
                    <Column field="start_date" header={Localize("START_DATE")} body={dateBodyTemplate} sortable />
                    <Column field="end_date" header={Localize("END_DATE")} body={dateBodyTemplate} sortable />
                </DataTable>
            ) : (
                <p className="m-0">No mission history found.</p>
            )}
        </Dialog>
    );
}